import React from 'react'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import { GRID_IMAGE, IMAGE, METRO, TEXT, TITLE } from '../../../constants/itemTypes'
import FormElementData from '../../forms/FormElementData'
import addFormikData from '../../../functions/addFormikData'
import Translation from '../../Translation/cont/Translation'

const EditElement = ({itemData, onUpdateItem, closePagePath, itemType}) => {
    let typeTransId 
    let elementType

    if(itemType === TITLE) {
        typeTransId ="print_flyer_heading_element"
        elementType = 'headlineElements'
    } else if(itemType === TEXT) {
        typeTransId ="print_flyer_text_element"
        elementType = 'textElements'
    } else if(itemType === IMAGE) {
        typeTransId ="print_flyer_image_element"
        elementType = 'imageElements'

        if(!itemData.width) { 
            addFormikData(itemData, 'auto', 'width')
        }
        if(!itemData.height) {
            addFormikData(itemData, 'auto', 'height')
        }
        if(!itemData.position_x) {
            addFormikData(itemData, 'center', 'position_x')
        }
        if(!itemData.position_y) {
            addFormikData(itemData, 'center', 'position_y')
        }
    } else if(itemType === METRO) {
        typeTransId = 'print_flyer_metro_element'
        elementType ='metroElements'
    } else if(itemType === GRID_IMAGE)  {
        typeTransId = 'print_flyer_element_image_grid'
        elementType = 'gridImages'
    }


    if((itemType !== METRO || itemType !== GRID_IMAGE) && !itemData.payload) {
        addFormikData(itemData, '', 'payload')
    }

    const pageName = typeTransId ? itemData && (itemData.payload  || itemData.id)
        ? [<Translation key="type" id={typeTransId}/>, <Translation key="edit" id="print_flyer_edit" before=" "/>] 
        : [<Translation key="new" id="print_flyer_new" after=" "/>, <Translation key="type" id={typeTransId}/>] 
        : ''

    return (
        <WrapperPageSimple pageTitle={pageName} closePagePath={closePagePath}>
            <div className="program-page flyer site-content">
                {itemData && (itemType === TITLE || itemType === TEXT || elementType === 'imageElements' || itemType === METRO || itemType === GRID_IMAGE) ? (
                    <FormElementData
                        closePagePath={closePagePath}
                        itemData={itemData}
                        onUpdateItem={onUpdateItem}
                        itemType={itemType}
                        elementType={elementType}
                    />
                ) : (
                    <div><Translation id="no_data"/></div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default EditElement